import { Injectable } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { MessageService } from 'primeng/api';
import { NotificationType } from 'src/app/backend-client/models/SharedKernel/Messaging/SignalR/notification-type';
import { MxConstans, MxConstansService } from './mx.constans.service';

@Injectable({
  providedIn: 'root',
})
export class MxNotificationService {
  constructor(
    private messageService: MessageService,

    private i18nextPipe: I18NextPipe
  ) {}

  show(notification: MxNotification) {
    if (notification.clearMessages) {
      this.clear();
    }

    this.messageService.add({
      key: 'notification-toast',
      severity: notification.type,
      summary: this.normalizeText(
        notification.title
          ? notification.translate
            ? this.i18nextPipe.transform(notification.title)
            : notification.title
          : notification.type
      ),
      detail: this.normalizeText(
        notification.translate
          ? this.i18nextPipe.transform(notification.message)
          : notification.message
      ),
      rawDetails: notification.rawDetails,
      life: notification.life ? notification.life : 5000,
      sticky: notification.sticky,
      icon: this.getNotificationIcon(notification),
    } as any);
  }

  private normalizeText(value: string): string {
    if (!value) {
      return value;
    }

    try {
      let normalized = value;

      for (let i = 0; i < 3; i++) {
        const decoded = decodeURIComponent(escape(normalized));
        if (decoded === normalized) {
          break;
        }

        normalized = decoded;
      }

      return normalized;
    } catch {
      return value;
    }
  }

  getNotificationIcon(notification: MxNotification): string {
    switch (notification.type) {
      case MxNotificationSeverity.Info:
        return MxConstansService.get(MxConstans.ICON_INFO);

      case MxNotificationSeverity.Success:
        return MxConstansService.get(MxConstans.ICON_SUCCESS);

      case MxNotificationSeverity.Error:
        return MxConstansService.get(MxConstans.ICON_ERROR);

      case MxNotificationSeverity.Warn:
        return MxConstansService.get(MxConstans.ICON_WARN);
    }
  }

  getNotificationSeverityByBackendNotificationType(
    notificationType: NotificationType
  ): MxNotificationSeverity {
    switch (notificationType) {
      case NotificationType.Info:
        return MxNotificationSeverity.Info;

      case NotificationType.Success:
        return MxNotificationSeverity.Success;

      case NotificationType.Error:
        return MxNotificationSeverity.Error;

      case NotificationType.Warn:
        return MxNotificationSeverity.Warn;
    }
  }

  clear() {
    this.messageService.clear();
  }
}

export interface MxNotification {
  type: MxNotificationSeverity;
  title?: string;
  message: string;
  sticky?: boolean;
  life?: number;
  clearMessages?: boolean;
  translate?: boolean;
  rawDetails?: string;
}

export enum MxNotificationSeverity {
  Success = 'success',
  Info = 'info',
  Warn = 'warn',
  Error = 'error',
}
